import React, { useState } from 'react';
import styles from './control-page.module.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function ControlPage() {
  const navigate = useNavigate();
  const [showList, setShowList] = useState(false);

  const controlSleepAndWater = [
    {
      id: 'sfsffffdfff33',
      fullName: 'Іван Мельничук',
      date_day: 'пн',
      date: '15.10.2024',
      date_time: '03:24:32',
      sleep_values_text: '7:00',
      sleep_values: 7.0,
      water_value: 1.5,
    },
    {
      id: 'sfsffffdffsf33',
      fullName: 'Іван Мельничук',
      date_day: 'вт',

      date: '15.10.2024',
      date_time: '03:24:32',
      sleep_values_text: '7:30',
      sleep_values: 7.3,
      water_value: 1.25,
    },
    {
      id: 'sfsffffvdfff33',
      fullName: 'Іван Мельничук',
      date_day: 'ср',

      date: '15.10.2024',
      date_time: '03:24:32',
      sleep_values_text: '7:00',
      sleep_values: 7.0,
      water_value: 1.5,
    },
  ];

  const renderSleepAndWater = (items) => {
    return items.map((item, index) => {
      return (
        <div key={item.id} className={styles.statistics_item}>
          <div className={styles.statistics_client_name}>
            {index + 1}) {item.fullName}
          </div>
          <div>
            <div
              className={
                item.sleep_values >= 7
                  ? styles.statistics_sleep_value + ' ' + styles.statistics_value
                  : styles.statistics_not_norm + ' ' + styles.statistics_value
              }
              style={{ width: item.sleep_values * 10 + 'px' }}>
              {item.sleep_values_text} год
            </div>
            <div
              className={
                item.water_value >= 1.5
                  ? styles.statistics_water_value + ' ' + styles.statistics_value
                  : styles.statistics_not_norm + ' ' + styles.statistics_value
              }
              style={{ width: item.water_value * 46.6 + 'px' }}>
              {item.water_value} л
            </div>
          </div>
        </div>
      );
    });
  };

  // Рендерить список днів
  const renderSelectedList = (list) => {
    return list.map((item, index) => {
      return true ? (
        <div key={item.id} className={styles.selected_list_item + ' ' + styles.active}>
          вт --.--.----
        </div>
      ) : (
        <div
          key={item.id}
          className={styles.selected_list_item + ' ' + styles.interaction_item}
          onClick={() => console.log('-')}>
          День {item.dayNumber}
        </div>
      );
    });
  };
  return (
    <>
      {/* -------------- Header ------------------------ */}
      <div className={styles.header_wrapper}>
        <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
        <div className={styles.selected_wrapper}>
          {true > 0 ? (
            <svg
              onClick={() => console.log('-')}
              className={styles.interaction_item}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.999998 13.732C-0.333335 12.9622 -0.333333 11.0377 1 10.2679L17.5 0.741669C18.8333 -0.0281316 20.5 0.93412 20.5 2.47372V21.5263C20.5 23.0659 18.8333 24.0281 17.5 23.2583L0.999998 13.732Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              className={styles.opacity_0}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.999998 13.732C-0.333335 12.9622 -0.333333 11.0377 1 10.2679L17.5 0.741669C18.8333 -0.0281316 20.5 0.93412 20.5 2.47372V21.5263C20.5 23.0659 18.8333 24.0281 17.5 23.2583L0.999998 13.732Z"
                fill="white"
              />
            </svg>
          )}

          <div className={styles.selected_day_wrapper}>
            {true ? (
              <div
                className={styles.selected_day + ' ' + styles.interaction_item}
                onClick={() => console.log('--')}>
                вт 22.10.2024
                <svg
                  className={showList ? styles.show : ''}
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.60218 10.8556C8.80231 11.9262 7.19769 11.9262 6.39782 10.8556L0.86245 3.44708C-0.122997 2.12816 0.81822 0.25 2.46463 0.25H13.5354C15.1818 0.25 16.123 2.12816 15.1375 3.44709L9.60218 10.8556Z"
                    fill="white"
                  />
                </svg>
              </div>
            ) : (
              <div className={styles.selected_day}></div>
            )}

            {/* {true ? <div className={styles.selected_list}>{renderSelectedList([1, 1])}</div> : ''} */}
          </div>

          {true ? (
            <svg
              onClick={() => console.log('-')}
              className={styles.interaction_item}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10.268C21.3333 11.0378 21.3333 12.9623 20 13.7321L3.5 23.2583C2.16667 24.0281 0.5 23.0659 0.5 21.5263V2.47372C0.5 0.934118 2.16667 -0.0281307 3.5 0.74167L20 10.268Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              className={styles.opacity_0}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10.268C21.3333 11.0378 21.3333 12.9623 20 13.7321L3.5 23.2583C2.16667 24.0281 0.5 23.0659 0.5 21.5263V2.47372C0.5 0.934118 2.16667 -0.0281307 3.5 0.74167L20 10.268Z"
                fill="white"
              />
            </svg>
          )}
        </div>
      </div>
      {/* -------------- /Header ------------------------ */}

      <div className={styles.content_wrapper}>
        <div className={styles.statistics_date}>Вівторок 22.10.2024</div>
        {renderSleepAndWater(controlSleepAndWater)}
        <div className={styles.line_control}></div>
      </div>
    </>
  );
}
